/*
 * @Author: YuanYuan
 * @Date: 2024-02-23 10:14:00
 * @LastEditTime: 2024-02-23 10:15:48
 * @description: 生成唯一uuid
 */
import { random } from 'lodash-es'

const RFC4122_TEMPLATE = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'

const replacePlaceholders = placeholder => {
  let value = random(15)
  value = placeholder === 'x' ? value : (value & 0x3 | 0x8)
  return value.toString(16)
}

export default () => RFC4122_TEMPLATE.replace(/[xy]/g, replacePlaceholders)
